/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import * as wjcCore from "@grapecity/wijmo"
import * as wjcInput from "@grapecity/wijmo.input"
import * as WjRInput from "@grapecity/wijmo.react.input"

import React, { useEffect, useRef, useState } from "react"

import dayjs from "dayjs"

type TMonthInput = {
  className?: string
  autoFocus?: boolean
  id?: string
  format?: string
  isRequired?: boolean
  isReadOnly?: boolean
  placeholder?: string
  isDisabled?: boolean
  defaultValue?: string
  value: string | null | undefined
  setValue: (value: string | null | undefined) => unknown
}

const MonthInput: React.FC<TMonthInput> = ({
  className,
  autoFocus,
  defaultValue,
  setValue,
  value,
  id,
  format = "yyyy/MM",
  isRequired = false,
  isReadOnly,
  placeholder,
  isDisabled,
}) => {
  const target = useRef(null)
  const defaultDateValue =
    defaultValue != null
      ? dayjs(defaultValue).isValid()
        ? dayjs(defaultValue).toDate()
        : undefined
      : null

  const [dateValue, setDateValue] = useState<Date | null | undefined>(
    defaultDateValue
  )
  const [classNameInner, setClassNameInner] = useState("")

  const checkInvalidValue = (
    s: wjcInput.InputDate,
    e: wjcCore.CancelEventArgs
  ) => {
    let tmp = s.text.replace(/T.[0-9]:.[0-9]:.[0-9]/g, "")
    let str = tmp.replace(/-/g, "")
    if (str.match("[0-9]{6}")) {
      let y = str.substring(0, 4)
      let m = str.substring(4, 6)
      let dayStr = y + "-" + m
      let inputDay = dayjs(dayStr).format("YYYY/MM")
      s.text = inputDay
      e.cancel = false
    }
  }

  // placeHolderとfloatinglabel用
  const [innerText, setInnerText] = useState<string>()
  const [isShowFloatingLabel, setIsShowFloatingLabel] = useState<boolean>()

  // valueの上書きがループしないよう制御
  const [isValueChanged, setIsValueChanged] = useState(false)

  useEffect(() => {
    if (
      placeholder &&
      innerText != null &&
      innerText !== "" &&
      value != null &&
      value !== ""
    ) {
      setIsShowFloatingLabel(true)
    } else {
      setIsShowFloatingLabel(false)
    }
  }, [innerText, placeholder, value])

  useEffect(() => {
    // valueChangedが走り終わった後に処理する
    if (!isValueChanged && value == null) return

    // valueをcomponent内のstateにセット
    if (value != null && dayjs(value).isValid()) {
      // dateValueに変更がなければスルー
      if (!dayjs(value).isSame(dateValue)) {
        setDateValue(dayjs(value).toDate())
      }
    } else {
      if (dateValue != null) {
        setDateValue(null)
      }
    }
    setIsValueChanged(false)
  }, [value])

  // classあて
  useEffect(() => {
    const classNameArray: string[] = []
    isRequired && classNameArray.push("required_input")
    className && classNameArray.push(className)
    if (classNameArray.length > 0) {
      setClassNameInner(classNameArray.join(" "))
    } else {
      setClassNameInner("")
    }
  }, [isRequired, className])

  return (
    <div ref={target} className="floating-frame">
      {isShowFloatingLabel && (
        <span className="floating-label">{placeholder}</span>
      )}
      <WjRInput.InputDate
        id={id}
        format={format}
        className={classNameInner}
        isRequired={isRequired}
        isReadOnly={isReadOnly}
        defaultValue={defaultDateValue}
        value={dateValue}
        selectionMode={wjcInput.DateSelectionMode.Month}
        placeholder={isShowFloatingLabel ? "" : placeholder ?? ""}
        isDisabled={isDisabled}
        invalidInput={checkInvalidValue}
        valueChanged={(s: wjcInput.InputDate, e: wjcCore.EventArgs) => {
          if (isRequired && !wjcCore.isDate(s.value)) {
            wjcCore.toggleClass(s.hostElement, "is-error", true)
          } else {
            wjcCore.toggleClass(s.hostElement, "is-error", false)
            if (s.value && dayjs(s.value).isValid()) {
              setValue(dayjs(s.value).toISOString())
              // setValue(dayjs(s.value).format())
            } else {
              setValue(null)
            }
          }
          setIsValueChanged(true)
        }}
        textChanged={(control: wjcInput.InputDate) => {
          setInnerText(control.text)
        }}
        initialized={(control: wjcInput.InputDate) => {
          if (autoFocus) control.inputElement?.focus()
        }}
      />
    </div>
  )
}

export default MonthInput
